import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { connect } from "react-redux";
import Button from "material-ui/Button";
import Snackbar from "../Parts/Snackbar.jsx";
import NotificationBar from "../Parts/NotificationBar.jsx";
import { CircularProgress } from "material-ui/Progress";
import PlanDialog from "../SendLetter/dialogs/PlanDialog";
import { isFreePlan } from "../../utils/planUtils.js";

import * as selector from "../../redux/selectors/accountSettingSelector";
import moment from "moment";

const styles = () => ({
  notification: {
    zIndex: 999,
    width: "100%",
    boxSizing: " border-box",
    padding: "13px 20px",
    backgroundColor: "#FFF3C6",
    color: " #181819",
    textAlign: "center",
    transition: "all 1s",
  },

  iconButton: {
    position: "absolute",
    top: "15px",
    right: "15px",
    width: "unset",
    height: "unset",
  },

  bannerTitle: {
    margin: "10px 0px",
    fontSize: "15px",
    fontWeight: "bold",
  },

  bannerText: {
    marginBottom: "8",
    fontSize: "13px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },

  freePlanNotification: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  detailButton: {
    color: "#181819",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    padding: "1px",
    marginLeft: "10px",
    textDecoration: "underline",
  },
});

class Wrapper extends React.Component {
  state = {
    showPostExecListSnackbar: false,
    showExcelSnackbar: false,
    showDeleteSnackbar: false,
    showImageSnackbar: false,
    showUpdateTagSnackbar: false,
    showVerifyingSnackbar: false,
    showCsvSnackbar: false,
    showOverwriteWarningAddressesSnackbar: false,
    showSyncSnackbar: false,
    showNotification: false,
    showRevokeSnackbar: false,
    message: "",
    messageType: "success",
    showNotificationBanner: true,
    showPlanExpirationNotification: true,
    showPlanDialog: false,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      showPostExecListSnackbar:
        nextProps.isPostingExecutiveList && !nextProps.showPostoExecListDialog,
      showExcelSnackbar: nextProps.isUploadingExcel,
      showDeleteSnackbar: nextProps.isDeleting,
      showImageSnackbar: nextProps.isUploadingImage || nextProps.isLoadingImage,
      showUpdateTagSnackbar:
        nextProps.isUpdatingTags || nextProps.isDeletingTags,
      showVerifyingSnackbar: nextProps.isVerifying,
      showCsvSnackbar: nextProps.isLoadingCsv,
      showOverwriteWarningAddressesSnackbar:
        nextProps.isOverwritingWarningAddresses,
      showSyncSnackbar:
        nextProps.isJobCompletedLoading || nextProps.isConfiguringSalesforce,
      showRevokeSnackbar: nextProps.isRevoking,
    });

    if (
      nextProps.salesforceMessage &&
      nextProps.salesforceMessage !== "" &&
      this.props.salesforceMessage !== nextProps.salesforceMessage
    ) {
      this.displayNotification(nextProps.salesforceMessage, "success");
    }
  }

  toggleNotificationBanner = () => {
    const { user } = this.props;
    let user_id = user && user.id ? user.id : "";

    sessionStorage.setItem(
      `show-free-plan-banner-notif-${user_id}`,
      JSON.stringify(0)
    );

    this.setState({
      showNotificationBanner: false,
    });
  };

  togglePlanExpirationNotification = () => {
    const { user } = this.props;
    let user_id = user && user.id ? user.id : "";

    sessionStorage.setItem(
      `show-free-plan-expiration-notif-${user_id}`,
      JSON.stringify(0)
    );

    this.setState({
      showPlanExpirationNotification: false,
    });
  };

  togglePlanDialog = () => {
    this.setState({ showPlanDialog: !this.state.showPlanDialog });
  };

  getUserId = () => {
    const { user } = this.props;
    return user && user.id ? user.id : "";
  };

  getBannerHeight = () => {
    return this.node && this.node.clientHeight ? this.node.clientHeight : 0;
  };

  showBannerThisSession = (user_id) => {
    return (
      JSON.parse(
        sessionStorage.getItem(`show-free-plan-banner-notif-${user_id}`)
      ) !== 0 && this.state.showNotificationBanner
    );
  };

  showFreePlanExpirationThisSession = (user_id) => {
    return (
      JSON.parse(
        sessionStorage.getItem(`show-free-plan-expiration-notif-${user_id}`)
      ) !== 0 && this.state.showPlanExpirationNotification
    );
  };

  getExpirationAt = () => {
    const { user } = this.props;

    return user && user.current_plan_expiration_at
      ? moment(user.current_plan_expiration_at)
      : moment("3000-01-01");
  };

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  renderSnackbar = (onClick, message, open) => {
    const closeBtn = (
      <div
        style={{
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        非表示
      </div>
    );

    return (
      <Snackbar
        icon={
          <CircularProgress
            style={{ color: "#6F9EFF", height: "24px", width: "24px" }}
          />
        }
        message={message}
        action={closeBtn}
        open={open}
        position="bottom left"
      />
    );
  };

  renderExcelSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({
          showExcelSnackbar: false,
          showPostExecListSnackbar: false,
        });
      },
      this.state.showPostExecListSnackbar
        ? "ターゲットリストに追加中..."
        : "アップロード中...",
      this.state.showExcelSnackbar || this.state.showPostExecListSnackbar
    );
  };

  renderDeleteSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showDeleteSnackbar: false });
      },
      "削除中...",
      this.state.showDeleteSnackbar
    );
  }

  renderSyncSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showSyncSnackbar: false });
      },
      this.props.isConfiguringSalesforce ? "同期設定を保存中..." : "同期中...",
      this.state.showSyncSnackbar
    );
  };

  renderImageSnackbar = () => {
    let text = this.props.isUploadingImage
      ? "画像をアップロード中..."
      : "画像をローディング中...";

    return this.renderSnackbar(
      () => {
        this.setState({ showImageSnackbar: false });
      },
      text,
      this.state.showImageSnackbar
    );
  };

  renderUpdateTagSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showUpdateTagSnackbar: false });
      },
      "処理中…",
      this.state.showUpdateTagSnackbar
    );
  };

  renderVerifyingSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showVerifyingSnackbar: false });
      },
      "登記簿と照合中…",
      this.state.showVerifyingSnackbar
    );
  };

  renderCsvSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showCsvSnackbar: false });
      },
      "CSVデータを作成中…",
      this.state.showCsvSnackbar
    );
  };

  renderOverwriteWarningAddressesSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showOverwriteWarningAddressesSnackbar: false });
      },
      "登録中…",
      this.state.showOverwriteWarningAddressesSnackbar
    );
  };

  renderRevokeSnackbar = () => {
    return this.renderSnackbar(
      () => {
        this.setState({ showRevokeSnackbar: false });
      },
      "連携を解除中...",
      this.state.showRevokeSnackbar
    );
  };

  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div
          style={{
            position: "fixed",
            zIndex: 10000,
            top: 10,
            width: "98%",
            left: "1%",
          }}
        >
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false });
            }}
            autoClose={false}
            style={{
              width:
                this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  renderPlanExpirationNotification = () => {
    const { classes } = this.props;

    const expiration_at = this.getExpirationAt();
    const daysUntilExpiration = Math.floor(
      moment.duration(expiration_at.diff(moment())).as("days")
    );

    let height = this.getBannerHeight();
    const top = 10;
    let user_id = this.getUserId();
    let showBannerThisSession = this.showBannerThisSession(user_id);

    const dayCountAt2Week = 14;
    if (isFreePlan(this.props.user) && daysUntilExpiration < dayCountAt2Week) {
      return (
        <div
          style={{
            position: "fixed",
            zIndex: 10001,
            top: showBannerThisSession ? top + height : top,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <NotificationBar
            message={`無料期間終了まであと${daysUntilExpiration}日`}
            type="yellow"
            open={this.showFreePlanExpirationThisSession(user_id)}
            onHandleClose={this.togglePlanExpirationNotification}
            autoClose={false}
            disableOnclickListener={true}
            animation="fade"
          ></NotificationBar>
        </div>
      );
    } else if (expiration_at.isBefore(moment())) {
      return (
        <div
          style={{
            position: "fixed",
            zIndex: 10001,
            top: showBannerThisSession ? top + height : top,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <NotificationBar
            message={
              <div className={classes.freePlanNotification}>
                <span>14日間を過ぎたため、無料トライアルは終了しました。</span>
                <Button
                  onClick={this.togglePlanDialog}
                  className={classes.detailButton}
                >
                  詳細
                </Button>
              </div>
            }
            type="yellow"
            open={this.showFreePlanExpirationThisSession(user_id)}
            onHandleClose={this.togglePlanExpirationNotification}
            autoClose={false}
            disableOnclickListener={true}
            animation="fade"
          ></NotificationBar>
        </div>
      );
    }
  };

  renderPlanDialog = () => (
    <PlanDialog
      isOpen={this.state.showPlanDialog}
      toggleDialog={this.togglePlanDialog}
    />
  );

  render() {
    return (
      <div className={this.props.className}>
        {this.renderPlanExpirationNotification()}
        {this.renderExcelSnackbar()}
        {this.renderDeleteSnackbar()}
        {this.renderImageSnackbar()}
        {this.renderUpdateTagSnackbar()}
        {this.renderVerifyingSnackbar()}
        {this.renderCsvSnackbar()}
        {this.renderOverwriteWarningAddressesSnackbar()}
        {this.renderSyncSnackbar()}
        {this.renderRevokeSnackbar()}
        {this.renderNotification()}
        {this.renderPlanDialog()}
        {this.props.children}
      </div>
    );
  }
}

Wrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  isPostingExecutiveList: PropTypes.bool,
  isUploadingExcel: PropTypes.bool,
  isUploadingImage: PropTypes.bool,
  isLoadingImage: PropTypes.bool,
  isUpdatingTags: PropTypes.bool,
  isDeleting: PropTypes.bool,
  isDeletingTags: PropTypes.bool,
  isVerifying: PropTypes.bool,
  isLoadingCsv: PropTypes.bool,
  isOverwritingWarningAddresses: PropTypes.bool,
  isJobCompletedLoading: PropTypes.bool,
  isConfiguringSalesforce: PropTypes.bool,
  showPostoExecListDialog: PropTypes.bool,
  salesforceMessage: PropTypes.string,
  isRevoking: PropTypes.bool,
  user: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
};

const mapStateToProps = (state) => {
  return {
    showPostoExecListDialog: state.executiveList.showPostoExecListDialog,
    isPostingExecutiveList: false,
    isUploadingExcel: state.addressBook.isUploadingExcel,
    isDeleting: state.addressBook.isDeleting,
    isUpdatingTags:
      state.addressBook.isUpdatingTags || state.executiveList.isUpdatingTags,
    isDeletingTags:
      state.addressBook.isDeletingAddressTags ||
      state.executiveList.isDeletingTags,
    isVerifying: state.addressBook.isVerifying,
    isLoadingCsv: state.executiveList.isLoadingCsv,
    isOverwritingWarningAddresses:
      state.addressBook.isOverwritingWarningAddresses,
    isJobCompletedLoading: state.broadcasting.isJobCompletedLoading,
    isConfiguringSalesforce: state.salesforce.isConfiguring,
    salesforceMessage: state.salesforce.message,
    isRevoking: state.salesforce.isRevoking,
    user: selector.getUser(state),
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Wrapper)
);



// WEBPACK FOOTER //
// ./src/components/common/Wrapper.jsx